export default "__VITE_ASSET__DPLVCvzD__"